"use client";
import { matchRoute } from "@softmax/web-addresses";
import { usePathname } from "./use-pathname";
import { useMemo } from "react";

export function useRoute() {
  const pathname = usePathname();
  return useMemo(() => ({ ...matchRoute(pathname), pathname }), [pathname]);
}
